export default __webpack_public_path__ + "static/media/logo-sm.8e3b8b04.png";